
    import Vue from "vue";

    const END_POINT = "/role";

    const getRole = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllRoles = data => Vue.axios.get(END_POINT, {params: data});

    const createRole = role => Vue.axios.post(END_POINT,  role );

    const createAllRoles = Roles => Vue.axios.post(END_POINT + "/all",  Roles );

    const updateRole = role => Vue.axios.put(END_POINT  + "/" + role.id,  role );

    const deleteRole = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getRole,
      getAllRoles,
      createRole,
      createAllRoles,
      updateRole,
      deleteRole
    };
    